module.exports = __webpack_public_path__ + "img/error.2215d685.png";